// extracted by css-extract-rspack-plugin
export default {"drilldownLoaderRoot":"drilldownLoaderRoot-NHbMas"};